import React from "react"

import { Tag } from "antd"
import { PurchaseOrderInvoicedStatusEnum } from "@finway-group/shared/lib/models"
import { useTranslation } from "react-i18next"

const statusClasses = {
    [PurchaseOrderInvoicedStatusEnum.NOT_INVOICED]: "ant-tag-red",
    [PurchaseOrderInvoicedStatusEnum.PARTIALLY_INVOICED]: "ant-tag-yellow",
    [PurchaseOrderInvoicedStatusEnum.FULLY_INVOICED]: "ant-tag-success",
}

interface PurchaseOrderInvoicedStatusTagProps {
    status: PurchaseOrderInvoicedStatusEnum
    short?: boolean
    className?: string
}

export const PurchaseOrderInvoicedStatusTag = ({ status, short = false, className = "" }: PurchaseOrderInvoicedStatusTagProps) => {
    const { t } = useTranslation()

    const label = short ? t(`purchaseOrders:invoicedStatus.short.${status}`) : t(`purchaseOrders:invoicedStatus.full.${status}`)

    return <Tag className={`${statusClasses[status]} ${className}`}>{label}</Tag>
}
